import React, {
  memo,
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from 'react'
import { IntakeContext } from 'context/IntakeContext'

// @mui material components
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'

// Material Icons
import IconButton from '@mui/material/IconButton'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'

// Soft UI Dashboard PRO React components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
// import styled from 'styled-components'
import { styled } from '@mui/material/styles'
import { CalculationDebug } from './components/CalculationDebug'

//Gauge Chart
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge'

// Dialog
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

//Accordion
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

import { useFegliCalculations } from './hooks/useFegliCalculations'
import { BalanceSheetModalForm } from './components/BalanceSheetModalForm'
import { UpdateFieldModalForm } from './components/UpdateFieldModalForm'
import { UpdateRetirementFieldModalForm } from './components/UpdateRetirementFieldModalForm'
import { apiClient } from 'utils/api/apiClient'
import LifeInsuranceRecommendations from './components/LifeInsuranceRecommendations'

import { LifeInsuranceSummary } from './components/LifeInsuranceSummary'
import { LifeInsuranceTable } from './components/LifeInsuranceTable'
import { callZapier } from 'utils/zapier/callZapier'
import {
  Box,
  Button,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  FormControlLabel,
  Menu,
  MenuItem,
  Switch,
} from '@mui/material'
import Slide from '@mui/material/Slide'
import CloseIcon from '@mui/icons-material/Close'
import EditIcon from '@mui/icons-material/Edit'
import MoreVertIcon from '@mui/icons-material/MoreVert'

// fegli edit modal
import { steps } from 'layouts/onboarding'
import { ModalOnboarding } from 'layouts/onboarding'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const RoundIcon = styled('div')(() => ({
  border: '1px solid #ddd',
  padding: '10px',
  borderRadius: '50%',
  width: '60px',
  height: '60px',
  margin: 'auto',
}))
export const Fegli = memo(() => {
  const { intakeState, updateUser, updateIntakeStateAtKey } =
    useContext(IntakeContext)
  const [id, setId] = useState()
  const [version, setVersion] = useState()
  const [type, setType] = useState()
  const [name, setName] = useState()
  const [plaidName, setPlaidName] = useState()
  const [subType, setSubType] = useState()
  const [sortKey, setSortKey] = useState()
  const [amount, setAmount] = useState()
  const [modalTitle, setModalTitle] = useState()
  const [open, setOpen] = useState(false)
  const [openFieldModal, setOpenFieldModal] = useState(false)
  const [openDialogModal, setOpenDialogModal] = useState(false)

  const [tableTimeHorizon, setTableTimeHorizon] = useState('monthly')
  const switchTimeHorizon = (event, newTimeHorizon) => {
    newTimeHorizon === null
      ? setTableTimeHorizon('monthly')
      : setTableTimeHorizon(newTimeHorizon)
  }
  const [anchorEl, setAnchorEl] = useState(null)
  const tableMenuOpen = Boolean(anchorEl)
  const handleTableMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleTableMenuClose = () => {
    setAnchorEl(null)
  }
  const [tableStates, setTableStates] = useState({
    age: false,
    retirement: false,
  })
  const handleTableStateChange = (event) => {
    setTableStates({
      ...tableStates,
      [event.target.name]: event.target.checked,
    })
  }

  const [openRetirementFieldModal, setOpenRetirementFieldModal] =
    useState(false)

  const {
    plannedRetirementMonth,
    plannedRetirementDay,
    plannedRetirementYear,
    bedb,
    totalEstate,
    grossCoverageNeeded,
  } = useFegliCalculations()
  const [assets, setAssets] = useState([])
  const [liabilities, setLiabilities] = useState([])
  const [deductions, setDeductions] = useState([])

  const getAccounts = useCallback(async () => {
    const {
      data: { items },
    } = await apiClient.get('api/assets')
    const foundAssets = items?.filter(({ type }) => type === 'asset') || []
    setAssets(foundAssets)
    const foundLiabilities =
      items?.filter(({ type }) => type === 'liability') || []
    setLiabilities(foundLiabilities)
    const foundDeductions =
      items?.filter(({ type }) => type === 'deduction') || []
    setDeductions(foundDeductions)
  }, [])

  // edit fegli inputs
  const [showModalOnboarding, setShowModalOnboarding] = useState(false)
  // console.log(steps)
  const remainingOnboardingSteps = useRef(
    steps.filter(
      (step) => step.tags?.includes('fegli')
      // !intakeState[step.props?.id] &&
      // (step?.dependencies || []).every(
      //   ({ attribute, value }) => intakeState[attribute] === value
      // )
    )
  )
  // console.log(remainingOnboardingSteps)
  const closeModalOnboarding = useCallback(() => {
    setShowModalOnboarding(false)
    // updating this ref ONLY works because the setShowModalOnboarding
    // updates state and triggers a rerender, which passes this into the
    // modal onboarding component
    remainingOnboardingSteps.current = steps.filter(
      (step) => step.tags?.includes('fegli')
      // !intakeState[step.props?.id] &&
      // (step?.dependencies || []).every(
      //   ({ attribute, value }) => intakeState[attribute] === value
      // )
    )
  }, [intakeState])
  // console.log(remainingOnboardingSteps.current)
  const openModalOnboarding = useCallback(() => {
    updateIntakeStateAtKey({ pickYourPath: 1 })
    handleTableMenuClose()
    setShowModalOnboarding(true)
  }, [])

  useEffect(() => {
    let fetched = false
    if (fetched) return

    getAccounts()
    fetched = true
  }, [getAccounts])

  const improveScoreHelp = () => {
    callZapier({
      user: intakeState,
      hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/3zmzqpy/',
      payload: {
        user: {
          firstName: intakeState.firstName,
          lastName: intakeState.lastName,
          phoneNumber: intakeState.phone,
          email: intakeState.email,
        },
      },
      sendNotification: true,
      notificationMessage:
        'A member of the PARCO team will reach out to you shortly! Expect a call to help improve your retirement readiness.',
    })
  }

  const handleSubmit = () => {
    handleClose()
  }

  const handleClose = () => {
    setOpen(false)
    setVersion('')
    setId('')
    setType('')
    setName('')
    setPlaidName('')
    setSubType('')
    setAmount('')
    setSortKey('')
    setModalTitle('')
  }
  const handleFieldModalClose = () => {
    setOpenFieldModal(false)
    updateUser()
  }
  const handleRetirementFieldModalClose = () => {
    setOpenRetirementFieldModal(false)
    updateUser()
  }
  const handleDialogModalOpen = () => {
    setOpenDialogModal(true)
  }
  const handleDialogModalClose = () => {
    setOpenDialogModal(false)
  }
  const handleCallMeClose = () => {
    improveScoreHelp()
    setOpenDialogModal(false)
  }
  const handleScheduleCallClose = () => {
    setOpenDialogModal(false)
  }

  //Currency Formatting
  const dollarFormat = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })

  const assetSum =
    (assets || []).map((assets) => assets.amount).reduce((a, b) => a + b, 0) +
    (intakeState?.tspBalance ? intakeState.tspBalance : 0) +
    (intakeState?.tspRothBalance ? intakeState.tspRothBalance : 0)

  const liabilitySum = (liabilities || [])
    .map((liabilities) => liabilities.amount)
    .reduce((a, b) => a + b, 0)

  const netWorth = assetSum - liabilitySum
  const totalEstateWithNetWorth = totalEstate + netWorth

  const legacyGap = isNaN(totalEstateWithNetWorth - grossCoverageNeeded)
    ? 0
    : totalEstateWithNetWorth - grossCoverageNeeded
  const legacyScore = isNaN(
    Math.round((totalEstateWithNetWorth / grossCoverageNeeded) * 100)
  )
    ? 0
    : Math.round((totalEstateWithNetWorth / grossCoverageNeeded) * 100)
  const legacyScoreMax = Math.min(legacyScore, 100)

  const gaugeSettings = {
    width: 150,
    height: 150,
    value: legacyScoreMax,
  }

  const gaugeColors = {
    full:
      legacyScore > 80 ? '#4CAF50' : legacyScore > 60 ? '#FFCA59' : '#FD5C70',
    highlight:
      legacyScore > 80 ? '#c9e7ca' : legacyScore > 60 ? '#fcf0d7' : '#feced4',
  }

  return (
    <DashboardLayout>
      <BalanceSheetModalForm
        handleClose={handleClose}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        open={open}
        handleSubmit={handleSubmit}
        reloadAccounts={getAccounts}
        modalHeader={modalTitle}
      />
      <UpdateFieldModalForm
        handleClose={handleFieldModalClose}
        open={openFieldModal}
        handleSubmit={handleFieldModalClose}
      />
      <UpdateRetirementFieldModalForm
        handleClose={handleRetirementFieldModalClose}
        open={openRetirementFieldModal}
        handleSubmit={handleRetirementFieldModalClose}
      />
      <Dialog
        open={openDialogModal}
        TransitionComponent={Transition}
        onClose={handleDialogModalClose}
        aria-labelledby="improve-score-dialog-title"
        aria-describedby="improve-score-dialog-description"
        key={open ? 'open' : 'closed'}
      >
        <DialogTitle
          id="improve-score-dialog-title"
          sx={{ paddingRight: '40px' }}
        >
          {'A PARCO Team Member is ready to help!'}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleDialogModalClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#344767',
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ padding: '0px 16px' }}>
          <DialogContentText id="improve-score-dialog-description">
            Let us know when we can contact you so we can work on getting you
            retirement ready by {plannedRetirementMonth} {plannedRetirementDay},{' '}
            {plannedRetirementYear}.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Button
            rel="noreferrer"
            size="large"
            variant="contained"
            sx={[
              {
                padding: '10px 24px 9px',
                backgroundColor: '#344767',
                color: '#fff',
                fontWeight: 'normal',
                boxShadow: 'none',
                marginBottom: { xs: '8px', sm: '0px' },
              },
              {
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#293852',
                  boxShadow: 'none',
                },
              },
            ]}
            onClick={handleCallMeClose}
          >
            CALL ME NOW
          </Button>
          <Button
            rel="noreferrer"
            size="large"
            variant="contained"
            sx={[
              {
                padding: '10px 24px 9px',
                backgroundColor: '#344767',
                color: '#fff',
                fontWeight: 'normal',
                boxShadow: 'none',
              },
              {
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#293852',
                  boxShadow: 'none',
                },
              },
            ]}
            href="https://team_parco.apptoto.com/"
            target="_blank"
            onClick={handleScheduleCallClose}
          >
            SCHEDULE A CALL
          </Button>
        </DialogActions>
      </Dialog>
      <DashboardNavbar />
      <SoftBox mt={0} p={{ xs: 1, lg: 3 }}>
        <SoftBox>
          <Grid container spacing={{ xs: 1, lg: 3 }}>
            {/* <Grid item xs={12} lg={6}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sx={{ border: '1px solid #D2D6DA', borderRadius: '8px' }}
                >
                  <Accordion
                    sx={{
                      '&.MuiPaper-root': {
                        borderRadius: '8px 8px 0 0',
                        boxShadow: 'none',
                        borderBottom: '1px solid #ddd',
                        marginBottom: '0',
                      },
                      '.MuiAccordionSummary-root': {
                        backgroundColor: gaugeColors.full,
                        borderRadius: '8px 8px 0 0',
                      },
                      '.MuiAccordionSummary-root.Mui-expanded': {
                        minHeight: '48px',
                      },
                      '.MuiAccordionSummary-content': {
                        margin: '0',
                        justifyContent: 'space-between',
                      },
                      '.MuiAccordionSummary-content>p': {
                        padding: '12px 0',
                      },
                    }}
                  >
                    <AccordionSummary
                      aria-controls="retirementGap-content"
                      id="retirementGap-header"
                    >
                      <Box
                        display="flex"
                        width="100%"
                        color="#fff"
                        justifyContent="space-between"
                        alignItems="center"
                        mt={3}
                      >
                        <Typography
                          variant="body2"
                          fontWeight="500"
                          textAlign="left"
                          fontSize={{ xs: '24px', md: '30px' }}
                        >
                          Your Life Insurance Gap:
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="500"
                          textAlign="right"
                          fontSize={{ xs: '24px', md: '30px' }}
                        >
                          {dollarFormat.format(legacyGap)}
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box p={1}>
                        <Typography textAlign="left" variant="h4" mb={2}>
                          Bridge Your Life Insurance Gap With A PARCO Team
                          Member!
                        </Typography>
                        <Typography textAlign="left" variant="body2">
                          Let us know when we can contact you so we can work on
                          bridging your life insurance gap as soon as possible!
                          This will be the key to increasing your Legacy score
                          to get you retirement ready.
                        </Typography>
                        <Box
                          mt={2}
                          display="flex"
                          justifyContent="space-between"
                        >
                          <Button
                            rel="noreferrer"
                            size="large"
                            variant="contained"
                            sx={[
                              {
                                padding: '10px 24px 9px',
                                backgroundColor: '#344767',
                                color: '#fff',
                                fontWeight: 'normal',
                                boxShadow: 'none',
                              },
                              {
                                '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                  {
                                    transform: 'none',
                                    backgroundColor: '#293852',
                                    boxShadow: 'none',
                                  },
                              },
                            ]}
                            onClick={handleCallMeClose}
                          >
                            CALL ME NOW
                          </Button>
                          <Button
                            rel="noreferrer"
                            size="large"
                            variant="contained"
                            sx={[
                              {
                                padding: '10px 24px 9px',
                                backgroundColor: '#344767',
                                color: '#fff',
                                fontWeight: 'normal',
                                boxShadow: 'none',
                              },
                              {
                                '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                  {
                                    transform: 'none',
                                    backgroundColor: '#293852',
                                    boxShadow: 'none',
                                  },
                              },
                            ]}
                            href="https://team_parco.apptoto.com/"
                            target="_blank"
                          >
                            SCHEDULE A CALL
                          </Button>
                        </Box>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  <LifeInsuranceTable deductions={deductions} />
                </Grid>
              </Grid>
            </Grid> */}
            <Grid item xs={12} lg={8}>
              <Grid container spacing={{ xs: 1, lg: 3 }}>
                <Grid item xs={12}>
                  <Card
                    sx={{
                      textAlign: 'left',
                      boxShadow: 0,
                      borderRadius: 2,
                      border: '1px solid #D2D6DA',
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      m={{ xs: 1, md: 2 }}
                      mb={{ xs: 1, md: 2 }}
                    >
                      <Typography
                        variant="h3"
                        fontWeight="medium"
                        fontSize={{ xs: '20px', md: '24px' }}
                        color="#75787B"
                      >
                        Life Insurance Summary
                      </Typography>
                      <Box>
                        <ToggleButtonGroup
                          value={tableTimeHorizon}
                          exclusive
                          onChange={switchTimeHorizon}
                          aria-label="TimeHorizon"
                          sx={{
                            height: '36px',
                            alignSelf: 'center',
                            borderRadius: '36px',
                            background: '#A3A7AA',
                            border: '3px solid #A3A7AA',
                          }}
                        >
                          <ToggleButton
                            sx={{
                              borderRadius: '36px !important',
                              border: 'none',
                              color: '#fff',
                              textTransform: 'capitalize',
                              fontWeight: '500',
                              letterSpacing: '0.5px',
                              '&.Mui-selected': {
                                backgroundColor: '#fff !important',
                                color: '#75787B',
                                fontWeight: '600',
                              },
                            }}
                            value="monthly"
                          >
                            Monthly
                          </ToggleButton>
                          <ToggleButton
                            sx={{
                              borderRadius: '36px !important',
                              border: 'none',
                              color: '#fff',
                              textTransform: 'capitalize',
                              fontWeight: '500',
                              letterSpacing: '0.5px',
                              '&.Mui-selected': {
                                backgroundColor: '#fff !important',
                                color: '#75787B',
                                fontWeight: '600',
                              },
                            }}
                            value="yearly"
                          >
                            Yearly
                          </ToggleButton>
                        </ToggleButtonGroup>
                        <IconButton
                          id="basic-button"
                          aria-controls={open ? 'basic-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                          onClick={handleTableMenuClick}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={tableMenuOpen}
                          onClose={handleTableMenuClose}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}
                        >
                          <MenuItem onClick={openModalOnboarding}>
                            <IconButton
                              sx={{
                                padding: '1px 16px 2px 10px',
                                color: '#344767',
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                            Edit Values
                          </MenuItem>
                          <MenuItem>
                            <FormControlLabel
                              control={
                                <Switch
                                  onChange={handleTableStateChange}
                                  checked={tableStates.age}
                                  name="age"
                                />
                              }
                              label="See Age Coverage"
                              sx={{
                                margin: 0,
                                '>span:last-of-type': {
                                  fontWeight: 400,
                                  marginLeft: '10px',
                                },
                              }}
                            ></FormControlLabel>
                          </MenuItem>
                          {/* <MenuItem>
                            <FormControlLabel
                              control={
                                <Switch
                                  onChange={handleTableStateChange}
                                  checked={tableStates.retirement}
                                  name="retirement"
                                />
                              }
                              label="See Retirement Premium"
                              sx={{
                                margin: 0,
                                '>span:last-of-type': {
                                  fontWeight: 400,
                                  marginLeft: '10px',
                                },
                              }}
                            ></FormControlLabel>
                          </MenuItem> */}
                        </Menu>
                      </Box>
                    </Box>
                    <Box display="flex">
                      <Box textAlign="left" width="100%">
                        <ModalOnboarding
                          open={showModalOnboarding}
                          handleClose={closeModalOnboarding}
                          modalHeader={'Update Life Insurance'}
                          steps={remainingOnboardingSteps.current}
                        />
                        <LifeInsuranceSummary
                          tableTimeHorizon={tableTimeHorizon}
                          tableStates={tableStates}
                        />
                      </Box>
                    </Box>
                  </Card>
                </Grid>
                {/* <Grid item xs={12}>
                  <Card
                    sx={{
                      textAlign: 'left',
                      boxShadow: 0,
                      borderRadius: 2,
                      border: '1px solid #D2D6DA',
                    }}
                  >
                    <Box p={{ xs: 2, md: 3 }} lineHeight={1}>
                      <Box display="flex">
                        <Box textAlign="left" width="100%">
                          <Typography
                            variant="h3"
                            fontWeight="medium"
                            color="#75787B"
                            mb={{ xs: 1, md: 2 }}
                            fontSize="18px"
                          >
                            My To Do List
                          </Typography>
                          <LifeInsuranceRecommendations />
                        </Box>
                      </Box>
                    </Box>
                  </Card>
                </Grid> */}

                {/* <Grid item xs={12}>
                  <Card
                    sx={{
                      textAlign: 'left',
                      boxShadow: 0,
                      borderRadius: 2,
                      border: '1px solid #D2D6DA',
                    }}
                  >
                    <Box p={{ xs: 2, md: 3 }} lineHeight={1}>
                      <Box display="flex">
                        <Box textAlign="left">
                          <Typography
                            variant="h3"
                            fontWeight="medium"
                            color="#75787B"
                            mb={{ xs: 1, md: 2 }}
                            fontSize="18px"
                          >
                            Legacy Preparedness Score
                          </Typography>
                          <Box
                            display="flex"
                            sx={{
                              backgroundColor: gaugeColors.highlight,
                              borderRadius: '75px 12px 12px 75px',
                            }}
                          >
                            <Gauge
                              {...gaugeSettings}
                              cornerRadius="50%"
                              sx={(theme) => ({
                                ['&.MuiGauge-root']: {
                                  overflow: 'visible',
                                  flexGrow: 'unset',
                                },
                                [`& .${gaugeClasses.valueText}`]: {
                                  fontSize: 48,
                                  fontWeight: 'bold',
                                },
                                [`& svg`]: {
                                  backgroundColor: '#fff',
                                  borderRadius: '50%',
                                  width: '150px',
                                  height: '150px',
                                },
                                [`& .${gaugeClasses.valueArc}`]: {
                                  fill: gaugeColors.full,
                                },
                                [`& .${gaugeClasses.referenceArc}`]: {
                                  fill: '#ddd',
                                },
                              })}
                            />
                            <Box
                              display="flex"
                              flexDirection="column"
                              alignSelf="center"
                              sx={{ padding: '5px 20px' }}
                            >
                              <Typography variant="h4" fontWeight="medium">
                                Legacy Score
                              </Typography>
                              <Typography variant="h6" fontWeight="medium">
                                {plannedRetirementDay
                                  ? `Based on your retirement goal of${' '}
                              ${plannedRetirementMonth} ${plannedRetirementDay},${' '}
                              ${plannedRetirementYear}.`
                                  : 'Based on your goal retirement date.'}
                              </Typography>
                            </Box>
                          </Box>
                          <Typography
                            variant="body2"
                            fontWeight="light"
                            mb={2}
                            mt={2}
                          >
                            You are currently {legacyScore}% covered. You have a{' '}
                            {dollarFormat.format(legacyGap)} Life Insurance
                            coverage{' '}
                            {legacyGap > 0
                              ? 'surplus. You are in great shape!'
                              : 'gap that still needs to be filled.'}
                          </Typography>
                          <Button
                            rel="noreferrer"
                            size="large"
                            variant="contained"
                            onClick={handleDialogModalOpen}
                            sx={[
                              {
                                padding: '10px 24px 9px',
                                backgroundColor: '#4CAF50',
                                color: '#fff',
                                fontWeight: 'normal',
                                boxShadow: 'none',
                                width: '100%',
                                marginBottom: '10px',
                              },
                              {
                                '&:hover, &:focus, &:active, &:focus:not(:hover)':
                                  {
                                    transform: 'none',
                                    backgroundColor: '#449d48',
                                    boxShadow: 'none',
                                  },
                              },
                            ]}
                          >
                            IMPROVE MY SCORE NOW
                          </Button>
                          <Typography variant="body2" fontWeight="light" mt={1}>
                            Your PARCO Legacy score is calculated using your
                            financial information and your retirement date. It
                            represents your life insurance coverage.
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Card>
                </Grid> */}
              </Grid>
            </Grid>
            {/* Change Back when we integrate with Plaid */}
          </Grid>
        </SoftBox>
        {process.env.DEBUG && <CalculationDebug />}
      </SoftBox>
      {/* <Footer /> */}
    </DashboardLayout>
  )
})

Fegli.displayName = 'Fegli'
